import axios from "axios";
import { contentConstants } from "./announcement-constant";
import { config } from "../../../../enviroment";

const announcements = (languageCode,customerClass) => async (dispatch) => {
  try {
    const res = await axios({
        url: config.urls.COMMUNICATION_SERVICE_BASE_URL,
              method: "post",
              headers: { "Content-Type": "application/json",languageCode:languageCode},
              data: {
                query:
                  `query{getAnnouncementList(input:{IsPublic:"LOGGED_IN",CustomerClass:"${customerClass}"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,IsPublic,ExpirationDateTime,CreateDateTime,StartDate,AnnouncementType,AnnouncementStatus,CustomerClass,IsPublic}}`
                },
    });
    dispatch({
      type: contentConstants.ANNOUNCEMENT_SUBMIT_SUCCESS,
      payload:res.data
    });
  } catch (error) {
    dispatch({
      type: contentConstants.ANNOUNCEMENT_SUBMIT_FAILURE,
      payload: error.message,
    });
  }
};

 const updateAnnouncementsVal = (no,prepaidTab,item) => dispatch => {
  dispatch({
       type: contentConstants.UPDATE_SELECTED_ALERT_PAGE ,
       updatedAnnouncementAction: item,
       announcementTab:no,
       prepaidTab:prepaidTab
   });
}


export {announcements,updateAnnouncementsVal};
